import React, {Component, createRef} from 'react';
import {connect} from 'react-redux';
import {Grid, Card, Radio} from '@material-ui/core';
import Header from 'Components/lto/common/Header';
import {T} from 'Actions/translate';
import {
    getShipToInfo,
    previewOrder,
    updatePreviewOrder,
    queryStContact,
    updateOfflineOrderCredential,
    getUploadFileLimit,
    get_CRD_Range,
    queryEoneInventory,
} from 'Actions/order';
import {addProxyOrder, uploadOffineFile} from 'Actions/ltoPurchaseOrder';
import BasicButton from 'Components/common/BasicButton';
import ShipToConfirm from 'Components/order/ShipToConfirm';
import BillToConfirm from 'Components/order/BillToConfirm';
import LabelInput from 'Components/common/LabelInput';
import ProductDetails from 'Components/lto/order/ProductDetails';
import SelectInput from 'Components/lto/common/SelectInput';
import BasicInput from 'Components/common/BasicInput';
import Select from 'Components/lto/common/Select';

import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';
import Dialog from 'Components/common/Dialog';
import Anchor from 'Components/common/Anchor';
import BaseImageUploader from 'Components/common/BaseImageUploader';
import {openNotification} from 'Actions/notification';
import Checkbox from '@material-ui/core/Checkbox';
import Input from 'Components/common/Input';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
    NO_SUPPLY_CENTER_ID,
    PURCHASE_ORDER_MODE,
    UPLOAD_FILE_LIMIT,
} from 'Utils/constant';
import {openTfsRuleUrl, openTfsChangeRuleUrl} from 'Utils/urlUtil';

// Icons
import {Attachment} from '@material-ui/icons';

class OrderConfirmation extends Component {
    inputFileRef = createRef();
    state = {
        poNumber: '',
        note: '',
        poNumberTF: '',
        noteTF: '',
        expectShipDate: util.dateFilter(new Date(), 'yyyy-MM-dd'),
        shipToConsignee: '',
        shipToPhone: '',
        billToConsignee: '',
        billToPhone: '',
        billToEmail: '',
        illegalEmail: true,
        shippmentType: 2,
        confirmDialogOpened: false,
        serachData: '',
        tabList: [
            {index: 0, text: T('supply_center_goods')},
            {index: 1, text: T('TFS_goods')},
        ],
        tabActive: 0,
        selectedValue: 0,
        rowId: '',
        billTofieldChange: false,
        checked: false,
        billToConsigneeSearch: false,
        // 'hasCheckTF': false
        isMobilityNotification: true,
        isSMS: false,
        isEmail: false,
        phoneNumberList: [],
        phoneNumber: '',
        phoneNumberId: '',
        currentPhoneNumber: '',
        emailList: [],
        emailId: '',
        defaultEmail: '',
        retentionTime: util.dateFilter(
            new Date().setDate(new Date().getDate() + 2),
            'yyyy-MM-dd',
        ),
        checkedPhoneNumberList: [],
        checkedEmailList: [],
        notificationMethods: [],
        offlineOrderSelectValue: 2,
        uploadCredentialDialogOpened: false,
        chooseImage: null,
        loading: false,
        imageStreamArr: [],
        uploadFileLimit: '',
        currentMaxFileSize: 0,
        offlineOrderTotalLimitExceed: false,
        orderLines: [],
        tfsOrderLines: [],
    };

    isAnnualAgreementCustomer = () => {
        const {annualAgreementCustomerFlag} = this.props;

        return (annualAgreementCustomerFlag || '').toUpperCase() === 'Y';
    };

    isOemOnlyOrder = () => {
        const {scmProducts, tfsProducts} = this.props;
        if (util.getPurchaseOrderMode() !== PURCHASE_ORDER_MODE.OFFLINE) {
            return false;
        }
        const scmOrderProducts = scmProducts || [];
        const tfsOrderProducts = tfsProducts || [];
        return (
            scmOrderProducts.length > 0 &&
            tfsOrderProducts.length === 0 &&
            scmOrderProducts.every((product) => product.productSource === 'OEM')
        );
    };

    getOfflineUploadTitle = () =>
        T(
            this.isAnnualAgreementCustomer()
                ? 'lto_purchase_order_upload_purchase_order_for_annual_agreement_customer'
                : 'lto_purchase_order_upload_purchase_order_for_non_annual_agreement_customer',
        );

    requestCRDRange = ({
        shipToNum,
        supplyCenterId,
        scmItems,
        tfsProducts,
        inventoryMap = {},
    }) => {
        const body = {
            shipToNum,
            supplyCenterId,
            items: scmItems.concat(
                tfsProducts.map((product) => {
                    const inventoryItem = inventoryMap[product.sku] || {};
                    const nextItem = {
                        catalogNumber: product.sku,
                        deliveryChannel: 'TFS',
                        quantity: product.quantity,
                        lineNumber: product.lineNumber,
                    };

                    if (
                        inventoryItem.availableInventory !== null &&
                        inventoryItem.availableInventory !== undefined
                    ) {
                        nextItem.inventory = inventoryItem.availableInventory;
                    }

                    if (inventoryItem.availabilityDate) {
                        nextItem.availabilityDate =
                            inventoryItem.availabilityDate;
                    }

                    return nextItem;
                }),
            ),
        };

        this.props.get_CRD_Range(body).then(() => {});
    };

    componentDidMount() {
        this.getPreviewOrder();
        const offlineOrderCredential = localStorage.getItem(
            'offlineOrderCredential',
        );
        let offlineOrderFileArr = [];
        if (
            offlineOrderCredential &&
            offlineOrderCredential !== '[object Object]'
        ) {
            let offlineOrderFileArr = JSON.parse(
                localStorage.getItem('offlineOrderCredential'),
            );
            this.props.updateOfflineOrderCredential(offlineOrderFileArr);
        } else {
            this.props.updateOfflineOrderCredential(offlineOrderFileArr);
        }
    }

    getPreviewOrder = () => {
        const {localData} = this.props;
        // let cartIds = [];
        let shipToNumber = util.getShipToNumber(localData);

        // cartIds = localData.skuPrices.map((item) => {
        // 	return item.cartId
        // });

        let previewOrderParams = {};
        if (this.getBatchAddSkuShipTo()) {
            previewOrderParams = {
                // 'cartIds': cartIds,
                orderNumbers: localData.orderNumbers,
                email: this.getBatchAddSkuEmail(),
                supplyCenterId: NO_SUPPLY_CENTER_ID,
                shipToNum: this.getBatchAddSkuShipTo(),
            };
        } else {
            previewOrderParams = {
                // 'cartIds': cartIds,
                orderNumbers: localData.orderNumbers,
                email: localData.customerEmail,
                supplyCenterId: localData.scId
                    ? localData.scId
                    : localData.defaultScId
                    ? localData.defaultScId
                    : NO_SUPPLY_CENTER_ID,
                shipToNum: shipToNumber,
            };
        }
        this.props.updatePreviewOrder({});
        this.props.previewOrder(previewOrderParams).then((res) => {
            const {receiverTel, invoiceReceiverEmail} = this.props;

            let tempPhoneNumberList = [];
            let phoneNumberListIndex = 1;

            let currentDisplayPrice = 1;
            if (res && res.data && res.status === 'success') {
                const scmItems = (res.data.scmProducts || [])
                    .filter((x) => !x.freeGoodItem)
                    .map((product) => ({
                        catalogNumber: product.sku,
                        deliveryChannel: 'SC',
                        quantity: product.quantity,
                        lineNumber: product.lineNumber,
                        inventory: product.inventory,
                        availabilityDate: product.eta,
                    }));
                const tfsProducts = (res.data.tfsProducts || []).filter(
                    (x) => !x.freeGoodItem,
                );
                const skuList = tfsProducts.map((product) => product.sku);
                if (scmItems.length || tfsProducts.length) {
                    const getInventoryPromise = skuList.length
                        ? this.props.queryEoneInventory({skuList})
                        : Promise.resolve(null);

                    getInventoryPromise
                        .then((response) => {
                            const inventoryMap = {};
                            if (
                                response &&
                                response.status === 'success' &&
                                Array.isArray(response.data)
                            ) {
                                response.data.forEach((item) => {
                                    inventoryMap[item.sku] = item;
                                });
                            }

                            this.requestCRDRange({
                                shipToNum: previewOrderParams.shipToNum,
                                supplyCenterId:
                                    previewOrderParams.supplyCenterId,
                                scmItems,
                                tfsProducts,
                                inventoryMap,
                            });
                        })
                        .catch(() => {
                            if (scmItems.length) {
                                this.requestCRDRange({
                                    shipToNum: previewOrderParams.shipToNum,
                                    supplyCenterId:
                                        previewOrderParams.supplyCenterId,
                                    scmItems,
                                    tfsProducts,
                                });
                            }
                        });
                }
                let loginAccountPhoneNumber = res.data.loginAccount
                    ? res.data.loginAccount.phone
                    : '';
                currentDisplayPrice =
                    res.data.shipTo.priceDisplayFlag === 'Y' ? 1 : 2;

                if (loginAccountPhoneNumber) {
                    tempPhoneNumberList.push({
                        id: phoneNumberListIndex,
                        name: loginAccountPhoneNumber,
                        isLoginAccountFlag: true,
                        receiverTel: loginAccountPhoneNumber,
                    });
                }
                if (
                    receiverTel &&
                    loginAccountPhoneNumber &&
                    receiverTel !== loginAccountPhoneNumber
                ) {
                    tempPhoneNumberList.push({
                        id: ++phoneNumberListIndex,
                        name: receiverTel,
                        receiverTel: receiverTel,
                    });
                }
            }

            let tempEmailList = [];
            if (invoiceReceiverEmail) {
                tempEmailList.push({
                    id: 1,
                    name: invoiceReceiverEmail,
                    invoiceReceiverEmail: invoiceReceiverEmail,
                });
            }
            console.log(
                'res.data.displayPrice',
                res.data.shipTo.priceDisplayFlag,
            );
            this.setState({
                phoneNumber: receiverTel,
                phoneNumberId:
                    tempPhoneNumberList.length > 0
                        ? tempPhoneNumberList[0].id
                        : '',
                checkedPhoneNumberList: tempPhoneNumberList,
                defaultEmail: invoiceReceiverEmail,
                checkedEmailList: tempEmailList,
                emailId: tempEmailList.length > 0 ? tempEmailList[0].id : '',
                phoneNumberList: tempPhoneNumberList,
                emailList: tempEmailList,
                selectedValue: currentDisplayPrice,
            });
        });
    };

    getBatchAddSkuEmail = () => {
        let currentBatchAddSkuEmail = '';
        if (
            this.props.location.state &&
            this.props.location.state.bacthAddSkuEmail
        ) {
            currentBatchAddSkuEmail =
                this.props.location.state.bacthAddSkuEmail;
        }
        return currentBatchAddSkuEmail;
    };

    getBatchAddSkuShipTo = () => {
        let currentBatchAddSkuShipTo = '';
        if (
            this.props.location.state &&
            this.props.location.state.batchAddSkuShipTo
        ) {
            currentBatchAddSkuShipTo =
                this.props.location.state.batchAddSkuShipTo;
        }
        return currentBatchAddSkuShipTo;
    };

    handleChange = (name, value, isNotEmail) => {
        const {invoiceReceiverTel, invoiceReceiverEmail, stContactQuery} =
            this.props;
        const {billToEmail} = this.state;
        let isChange = false;
        if (
            (name === 'billToPhone' && invoiceReceiverTel !== value) ||
            (name === 'billToEmail' && invoiceReceiverEmail !== value)
        ) {
            isChange = true;
        }
        if (name === 'billToEmail' && billToEmail && billToEmail !== value) {
            isChange = true;
            this.setState({
                rowId: undefined,
                billTofieldChange: isChange,
            });
        }
        if (typeof isNotEmail === 'undefined') {
            if (name === 'billToPhone') {
                this.setState({
                    [name]: value,
                    billTofieldChange: isChange,
                });
            } else {
                if (name === 'poNumber') {
                    this.setState({
                        [name]: value,
                        poNumberTF: value,
                    });
                } else if (name === 'note') {
                    this.setState({
                        [name]: value,
                        noteTF: value,
                    });
                } else if (name === 'shipToPhone') {
                    let tempPhoneNumberList = JSON.parse(
                        JSON.stringify(this.state.phoneNumberList),
                    );

                    //修改收货信息中的联系方式时，如果和loginAccount 中的phone相同时则去重，如果不一样时，将其添加到客户渠道的短信下拉中
                    let isNoChangeReceivePhoneFlag =
                        this.isNoChangeReceivePhone(tempPhoneNumberList, value);

                    let checkedTel = '';
                    if (
                        !isNoChangeReceivePhoneFlag &&
                        this.isValidPhoneNumber(value)
                    ) {
                        if (this.isExistOtherPhone(tempPhoneNumberList)) {
                            tempPhoneNumberList.length > 0 &&
                                tempPhoneNumberList.forEach((phoneItem) => {
                                    if (!phoneItem.isLoginAccountFlag) {
                                        checkedTel = phoneItem.name;
                                        phoneItem.name = value;
                                        phoneItem.receiverTel = value;
                                    }
                                });
                        } else {
                            console.log(
                                '000000000000000000000000000000000',
                                value,
                            );
                            tempPhoneNumberList.push({
                                id: tempPhoneNumberList.length + 1,
                                name: value,
                                isLoginAccountFlag: false,
                                receiverTel: value,
                            });
                        }
                    } else {
                        tempPhoneNumberList = tempPhoneNumberList.filter(
                            (obj) => obj.isLoginAccountFlag === true,
                        );
                    }

                    this.setState({
                        [name]: value,
                        phoneNumberList: tempPhoneNumberList,
                        // currentPhoneNumber: checkedTel
                    });
                } else {
                    this.setState({
                        [name]: value,
                    });
                }
            }
        } else {
            if (name === 'billToPhone') {
                this.setState({
                    [name]: value,
                    illegalEmail: isNotEmail,
                    billTofieldChange: isChange,
                });
            } else {
                this.setState({
                    [name]: value,
                    illegalEmail: isNotEmail,
                });
            }
        }
    };

    isValidPhoneNumber = (input) => {
        const phoneNumberRegex = /^(?:\+?86)?\s?\d{11}$/;
        return phoneNumberRegex.test(input);
    };

    isExistOtherPhone = (tempPhoneNumberList) => {
        let isExistOtherPhoneFlag = false;

        tempPhoneNumberList.length > 0 &&
            tempPhoneNumberList.forEach((phoneItem) => {
                if (
                    typeof phoneItem.isLoginAccountFlag !== 'undefined' &&
                    !phoneItem.isLoginAccountFlag
                ) {
                    isExistOtherPhoneFlag = true;
                }
            });

        return isExistOtherPhoneFlag;
    };

    isNoChangeReceivePhone = (tempPhoneNumberList, value) => {
        let isLoginAccountPhoneEquals = true;

        if (tempPhoneNumberList.length > 0) {
            tempPhoneNumberList.forEach((phoneItem, phoneIndex) => {
                if (phoneItem.name !== value && phoneItem.isLoginAccountFlag) {
                    isLoginAccountPhoneEquals = false;
                }
            });
        } else {
            isLoginAccountPhoneEquals = false;
        }

        return isLoginAccountPhoneEquals;
    };

    isPhoneNumberEmpty = () => {
        const {notificationMethods} = this.state;

        let isPhoneNumberNotEmpty = true;
        if (notificationMethods.length > 0) {
            notificationMethods.forEach((notificationMethodItem) => {
                if (
                    notificationMethodItem.method === 'sms' &&
                    !notificationMethodItem.receiver
                ) {
                    isPhoneNumberNotEmpty = false;
                }
            });
        }

        return isPhoneNumberNotEmpty;
    };

    isCheckedSendReceiverTel = () => {
        const {notificationMethods, phoneNumberList, currentPhoneNumber} =
            this.state;

        console.log(
            'currentPhoneNumber===========================',
            currentPhoneNumber,
        );
        let sendTel = '';
        let telExists = true;
        let isHaveSMS = false;
        if (notificationMethods && notificationMethods.length > 0) {
            notificationMethods.map((notificationItem) => {
                if (notificationItem.method === 'sms') {
                    isHaveSMS = true;
                    sendTel = notificationItem.receiver;
                }
            });
            if (isHaveSMS) {
                telExists = phoneNumberList.some(
                    (item) => item.name === currentPhoneNumber,
                );
            } else {
                telExists = true;
            }
        } else {
            telExists = true;
        }

        console.log('telExists===========================', telExists);

        return telExists;
    };

    submitOrder = () => {
        const {
            shipToConsignee,
            shipToPhone,
            billToConsignee,
            billToPhone,
            billToEmail,
            expectShipDate,
            tabActive,
            checked,
            illegalEmail,
            retentionTime,
            notificationMethods,
            currentPhoneNumber,
        } = this.state;
        const {tfsProducts, scmProducts, invoiceReceiverEmail, localData} =
            this.props;

        console.log(
            'notificationMethods----------submitOrder--------------',
            notificationMethods,
            this.state.phoneNumberList,
        );
        let body = document.getElementsByTagName('body')[0];
        const today = util.dateFilter(new Date(), 'yyyy-MM-dd');
        if (!shipToConsignee) {
            this.props.openNotification(
                T('pleaseEnter') + T('shipToConsignee'),
                'danger',
            );
        } else if (!shipToPhone) {
            this.props.openNotification(
                T('pleaseEnter') + T('shipToPhone'),
                'danger',
            );
        } else if (currentPhoneNumber && !this.isCheckedSendReceiverTel()) {
            this.props.openNotification(
                T('updateShipmentPhoneInformationReminder'),
                'danger',
            );
        } else if (!billToConsignee) {
            this.props.openNotification(
                T('pleaseEnter') + T('billToConsignee'),
                'danger',
            );
        } else if (!billToPhone) {
            this.props.openNotification(
                T('pleaseEnter') + T('billToPhone'),
                'danger',
            );
        } else if (!illegalEmail) {
            this.props.openNotification(T('errorEmail'), 'danger');
        } else if (!billToEmail) {
            this.props.openNotification(
                T('pleaseEnter') + T('email'),
                'danger',
            );
        } else if (!this.isPhoneNumberEmpty()) {
            this.props.openNotification(
                T('customer_confirmation_channel_checked_sms_not_empty'),
                'danger',
            );
        } else if (
            this.state.poNumberTF.length > 25 ||
            this.state.poNumber.length > 25
        ) {
            this.props.openNotification(
                T('notification_purchase_order_no_more_than_25_digits'),
                'danger',
            );
        } else if (!retentionTime) {
            this.props.openNotification(
                T('lto_purchase_order_retention_time_not_empty'),
                'danger',
            );
        } else if (retentionTime < today) {
            this.props.openNotification(
                T(
                    'lto_purchase_order_retention_time_is_less_than_the_current_date',
                ),
                'danger',
            );
        } else if (
            this.state.noteTF.length > 300 ||
            this.state.note.length > 300
        ) {
            this.props.openNotification(
                T('notification_note_message_is_too_long'),
                'danger',
            );
        } else if (!checked) {
            this.props.openNotification(
                T('notification_please_check_and_confirm_the_terms'),
                'danger',
            );
        } else if (expectShipDate < today) {
            this.props.openNotification(
                T(
                    'notification_expected_delivery_date_is_less_than_the_current_date',
                ),
                'danger',
            );
        } else {
            // if (
            //     tabActive === 0 &&
            //     tfsProducts.length > 0 &&
            //     scmProducts.length > 0
            // ) {
            //     this.getPreviewOrder();
            //     this.setState({
            //         tabActive: 1,
            //         // 'poNumberTF': this.state.poNumberTF || this.state.poNumber,
            //         // 			'noteTF': this.state.noteTF || this.state.note
            //     });
            //     window.scrollTo(
            //         0,
            //         document.getElementById('order-confirma-tab-header') &&
            //             document.getElementById('order-confirma-tab-header')
            //                 .scrollHeight +
            //                 body.clientHeight * 0.3,
            //     );
            // } else {
            //     this.setState({
            //         confirmDialogOpened: true,
            //     });
            // }

            if (
                localData.totalPrice > 60000 &&
                util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE
            ) {
                this.setState({
                    offlineOrderTotalLimitExceed: true,
                });
            } else if (
                localData.totalPrice <= 60000 &&
                util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE
            ) {
                this.confirmDialog();
            } else {
                this.setState({
                    confirmDialogOpened: true,
                });
            }
        }
    };

    getCurrentSubmitProductsScmList = (
        currentSubmitProductsList,
        isRevenueFlag,
    ) => {
        const {tfsProducts, scmProducts} = this.props;
        let listRevenue = 0;
        scmProducts.length > 0 &&
            scmProducts.map((scItem) => {
                if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
                    let currentPrice =
                        parseFloat(scItem.listPrice) * scItem.quantity;
                    listRevenue += currentPrice;
                } else {
                    currentSubmitProductsList.push(scItem);
                }
            });
        if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
            return listRevenue;
        } else {
            return currentSubmitProductsList;
        }
    };

    getCurrentSubmitProductsTfsList = (
        currentSubmitProductsList,
        isRevenueFlag,
    ) => {
        const {tfsProducts, scmProducts} = this.props;
        let listRevenue = 0;
        tfsProducts.length > 0 &&
            tfsProducts.map((tfsItem) => {
                if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
                    let currentTfsPrice =
                        parseFloat(tfsItem.listPrice) * tfsItem.quantity;
                    listRevenue += currentTfsPrice;
                } else {
                    currentSubmitProductsList.push(tfsItem);
                }
            });
        if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
            return listRevenue;
        } else {
            return currentSubmitProductsList;
        }
    };

    handleChangeRadio = (value) => {
        this.setState({
            shippmentType: value,
        });
    };

    confirmDialog = () => {
        const {
            localData,
            hostInfo,
            orderShipTo,
            tfsProducts,
            scmProducts,
            customerRowId,
            orderNumbers,
            invoiceReceiverEmail,
        } = this.props;
        const {
            billToConsignee,
            billToPhone,
            billToEmail,
            shipToConsignee,
            shipToPhone,
            poNumber,
            expectShipDate,
            note,
            shippmentType,
            poNumberTF,
            noteTF,
            selectedValue,
            rowId,
            billTofieldChange,
        } = this.state;
        let tfsProductList = [];
        let scmProductList = [];
        let shipToNumber = util.getShipToNumber(localData);

        // tfsProductList = tfsProducts && tfsProducts.map((item) => {
        // 	return {'cartId': item.cartId, 'discountPrice': this.getSkuPrice(item.cartId).finalPrice, 'extendedPrice': this.getSkuPrice(item.cartId).extendedPrice , 'listPrice':this.getSkuPrice(item.cartId).listPrice, 'lineNumber': this.getSkuPrice(item.cartId).lineNumber, 'webOnlyFlag': this.getSkuPrice(item.cartId).webOnlyFlag}
        // });
        // scmProductList = scmProducts && scmProducts.map((item) => {
        // 	return {'cartId': item.cartId, 'discountPrice': this.getSkuPrice(item.cartId).finalPrice, 'extendedPrice': this.getSkuPrice(item.cartId).extendedPrice, 'listPrice':this.getSkuPrice(item.cartId).listPrice, 'lineNumber': this.getSkuPrice(item.cartId).lineNumber, 'webOnlyFlag': this.getSkuPrice(item.cartId).webOnlyFlag}
        // });

        let pickUpType = 2;
        let supplyCenterId = null;

        if (this.getBatchAddSkuShipTo()) {
            supplyCenterId = null;
        } else {
            supplyCenterId = localData.scId
                ? localData.scId
                : localData.defaultScId
                ? localData.defaultScId
                : NO_SUPPLY_CENTER_ID;
        }

        let purchaseOrderMode = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            purchaseOrderMode = routerState.purchaseOrderMode;
        }
        // console.log(pickUpType, "==============================pickUpType");
        // console.log(this.state.notificationMethods, "==============================notificationMethods");
        // console.log(this.state.retentionTime, "==============================retentionTime");
        const orderLineList =
            this.state.orderLines.length > 0
                ? this.state.orderLines
                : this.props.scmProducts
                      .filter((x) => !x.freeGoodItem)
                      .map((item) => {
                          return {
                              sku: item.sku,
                              lineNumber: item.lineNumber,
                              crd: item.crd,
                              deliveryChannel: 'SC',
                          };
                      });
        const tfsOrderLineList =
            this.state.tfsOrderLines.length > 0
                ? this.state.tfsOrderLines
                : this.props.tfsProducts
                      .filter((x) => !x.freeGoodItem)
                      .map((item) => {
                          return {
                              sku: item.sku,
                              lineNumber: item.lineNumber,
                              crd: item.crd,
                              deliveryChannel: 'TFS',
                          };
                      });

        this.props
            .addProxyOrder({
                stAlphaName: orderShipTo.stAlphaName,
                displayPrice: selectedValue,
                email: this.getBatchAddSkuEmail()
                    ? this.getBatchAddSkuEmail()
                    : localData.customerEmail,
                hostId: hostInfo ? hostInfo.id : '',
                invoiceReceiver: billToConsignee,
                invoiceReceiverAddress: orderShipTo
                    ? util.formatAddress(
                          orderShipTo.btCity,
                          orderShipTo.btAddress,
                          orderShipTo.btBuilding,
                      )
                    : '',
                invoiceReceiverTel: billToPhone,
                invoiceReceiverEmail: billToEmail,
                invoiceTitle: orderShipTo ? orderShipTo.btInstitution : '',
                receiver: shipToConsignee,
                receiverAddress: orderShipTo
                    ? util.formatStAddress(
                          orderShipTo.stCity,
                          orderShipTo.stAddress,
                          orderShipTo.stBuilding,
                          orderShipTo.stDepartment,
                      )
                    : '',
                receiverTel: shipToPhone,
                shipToObj: orderShipTo,
                shipToNum: this.getBatchAddSkuShipTo()
                    ? this.getBatchAddSkuShipTo()
                    : shipToNumber,
                shippingType: pickUpType,
                supplyCenterId: supplyCenterId,
                promoCodes: localData.promoCodes,
                rowId: billTofieldChange ? rowId : customerRowId,
                scmOrderDetail: {
                    // 'orderProductDetails': scmProductList,
                    purchaseNo: poNumber,
                    remark: note,
                    salesOrderNumber: orderNumbers.scmOrderNumber,
                    orderLines: orderLineList,
                    // 'jobNumber': localData.scmJobNumber,
                },
                tfsOrderDetail: {
                    // 'orderProductDetails': tfsProductList,
                    purchaseNo: poNumberTF,
                    remark: noteTF,
                    // 'jobNumber': localData.tfsJobNumber,
                    salesOrderNumber: orderNumbers.tfsOrderNumber,
                    orderLines: tfsOrderLineList,
                },
                priceType: localData.priceType,
                orderChannel: util.getPurchaseOrderMode(),
                retentionTime: this.state.retentionTime,
                notificationMethods: this.state.notificationMethods,
                // orderProofs: this.state.imageStreamArr,
                orderProofs: this.props.offlineOrderCredential,
            })
            .then((res) => {
                this.setState(
                    {
                        pageLoading: false,
                        confirmDialogOpened: false,
                    },
                    () => this.orderSuccess(res, supplyCenterId),
                );
            })
            .catch((res) => {
                if (res && res.status === 'invalid_retention_time') {
                    this.props.openNotification(
                        T('retention_time_is_more_than_the_current_date', [
                            res.message,
                        ]),
                        'danger',
                    );
                } else if (res && res.status === 'dealer_bt_not_allowed') {
                    this.props.openNotification(
                        T('dealer_customer_info'),
                        'danger',
                    );
                } else if (res && res.status === 'oem_order_remark_required') {
                    this.props.openNotification(
                        T('oem_order_remark_required'),
                        'danger',
                    );
                } else if (
                    res &&
                    res.status === 'offline_order_total_limit_exceed'
                ) {
                    this.setState({
                        offlineOrderTotalLimitExceed: true,
                    });
                }
                this.setState({
                    pageLoading: false,
                    confirmDialogOpened: false,
                });
            });
    };

    getSkuPrice = (cartId) => {
        const {localData} = this.props;
        let skuDetails;

        skuDetails =
            localData.skuPrices &&
            localData.skuPrices.filter((item) => {
                return item.cartId === cartId;
            });

        return skuDetails[0] || '';
    };

    orderSuccess = (res, supplyCenterId) => {
        localStorage.setItem('offlineOrderCredential', []);
        this.props.history.push('/purchase/orderSuccess', {
            bacthAddSkuEmail: this.getBatchAddSkuEmail(),
            batchAddSkuShipTo: this.getBatchAddSkuShipTo(),
            supplyCenterId: supplyCenterId,
            customerEmail: util.getPurchaseCustomerEmail(),
            customerName: util.getPurchaseCustomerName(),
        });
    };

    handleSearch = (name, item, serachFlg) => {
        const {localData, invoiceReceiver, billToEmail, billToPhone} =
            this.props;
        let shipToNumber = util.getShipToNumber(localData);
        // console.log("name", name);
        // console.log("item", item);
        // console.log("serachFlg",  serachFlg);

        if (item && !serachFlg) {
            this.props.queryStContact({
                queryKey: item.name || item,
                shipToNum: this.getBatchAddSkuShipTo()
                    ? this.getBatchAddSkuShipTo()
                    : shipToNumber,
            });
        }
        if (serachFlg && item.email) {
            const strReg =
                /^\w+((-\w+)|(\.\w+))*\@{1}\w+\.{1}\w{2,4}(\.{0,1}\w{2}){0,1}/gi;
            const isRegFlag = item.email && item.email.search(strReg);
            let isEmailFlag = true;
            if (isRegFlag === -1) {
                isEmailFlag = false;
            }

            if (isEmailFlag) {
                this.handleChange('billToEmail', item.email, true);
            }
        }

        this.setState({
            [name]: item.name || item,
            billToConsignee: this.getCurrentInvoiceReceiver(
                name,
                item,
                serachFlg,
            ),
            billToPhone: serachFlg
                ? util.formateContactId(item.phoneNumber)
                : this.state.billToPhone,
            billToEmail: serachFlg
                ? item.email
                : this.props.invoiceReceiverEmail
                ? this.props.invoiceReceiverEmail
                : this.state.billToEmail,
            rowId: item.rowId,
            billTofieldChange:
                invoiceReceiver === item ? this.state.billTofieldChange : true,
            billToConsigneeSearch: serachFlg,
        });
    };

    getCurrentInvoiceReceiver = (name, item, serachFlg) => {
        let currentInvoiceReceiver = '';
        if (name === 'billToConsignee' && serachFlg) {
            currentInvoiceReceiver = item.fullName;
        } else {
            currentInvoiceReceiver = item.name || item;
        }

        return currentInvoiceReceiver;
    };

    handleChangeTab = (item) => {
        if (this.state.tabActive === item.index) {
            return;
        }
        this.getPreviewOrder();
        if (item.index === 1) {
            this.setState({
                // 'poNumberTF': this.state.poNumberTF || this.state.poNumber,
                // 'noteTF': this.state.noteTF || this.state.note,
                tabActive: item.index,
            });
        } else {
            this.setState({
                tabActive: item.index,
            });
        }
    };

    tabFilter = () => {
        const {tfsProducts, scmProducts} = this.props;
        let tabList = [];

        if (scmProducts && scmProducts.length > 0) {
            tabList.push({index: 0, text: T('supply_center_goods')});
        }

        if (tfsProducts && tfsProducts.length > 0) {
            tabList.push({index: 1, text: T('TFS_goods')});
        }

        return tabList;
    };

    handleOfflinePurchaseOrderRadio = (event) => {
        let value = event.target.value ? parseInt(event.target.value) : '';
        this.setState({
            offlineOrderSelectValue: value,
        });
    };

    closeDialog = () => {
        this.setState({
            confirmDialogOpened: false,
        });
    };

    handleChangeCheckbox = (name) => (event) => {
        this.setState({
            [name]: event.target.checked,
        });
    };

    handleRadio = (params) => {
        //  	if (params === 'noteTF'){
        //  		this.setState({
        // 	'noteTF': this.state.note
        // })
        //  	} else if (params === 'poNumber') {
        //  		this.setState({
        // 	'poNumberTF': this.state.poNumber
        // })
        //  	}
        this.setState({
            [params + 'TF']: this.state[params],
        });
    };

    handleCustomerConfirmationChannel = (params, value) => {
        // console.log(params, value);
        const {receiverTel, invoiceReceiverEmail} = this.props;
        const {
            phoneNumberList,
            emailList,
            phoneNumber,
            phoneNumberId,
            defaultEmail,
            emailId,
        } = this.state;
        this.setState(
            {
                [params]: !value,
            },
            () => {
                const {isSMS, isEmail, notificationMethods} = this.state;
                let tempNotificationMethods = [];
                let tempCurrentPhoneNumber = '';
                if (params === 'isSMS') {
                    if (isSMS) {
                        let isSMSObj = {
                            method: 'sms',
                            receiver: '',
                        };
                        console.log(
                            'currentPhoneNumber====================',
                            this.state.currentPhoneNumber,
                        );
                        if (phoneNumberList.length > 0) {
                            let currentPhoneObj = {};
                            phoneNumberList.forEach((phoneItem) => {
                                if (
                                    phoneNumberId &&
                                    phoneItem.id === phoneNumberId
                                ) {
                                    currentPhoneObj = phoneItem;
                                }
                            });

                            isSMSObj.receiver = currentPhoneObj.name;
                        } else {
                            isSMSObj.receiver = receiverTel;
                        }
                        // tempCurrentPhoneNumber = isSMSObj.receiver;
                        tempNotificationMethods.push(isSMSObj);
                        tempNotificationMethods =
                            tempNotificationMethods.concat(
                                this.state.notificationMethods,
                            );
                    } else {
                        const newNotificationMethods =
                            notificationMethods.filter(
                                (obj) => obj.method !== 'sms',
                            );
                        tempNotificationMethods = newNotificationMethods;
                        tempCurrentPhoneNumber = '';
                    }
                }

                if (params === 'isEmail') {
                    if (isEmail) {
                        let isEmailObj = {
                            method: 'mail',
                            receiver: '',
                        };
                        if (emailList.length > 0) {
                            let currentEmailObj = {};
                            emailList.forEach((emailItem) => {
                                if (emailItem.id === emailId) {
                                    currentEmailObj = emailItem;
                                }
                            });
                            isEmailObj.receiver = currentEmailObj.name;
                        } else {
                            isEmailObj.receiver = invoiceReceiverEmail;
                        }
                        tempNotificationMethods.push(isEmailObj);
                        tempNotificationMethods =
                            tempNotificationMethods.concat(
                                this.state.notificationMethods,
                            );
                    } else {
                        const newNotificationMethods =
                            notificationMethods.filter(
                                (obj) => obj.method !== 'mail',
                            );
                        tempNotificationMethods = newNotificationMethods;
                    }
                }

                // console.log(
                //     tempNotificationMethods,
                //     '0000000000000000notificationMethods-----------------',
                //     this.state.notificationMethods,
                // );

                this.setState({
                    notificationMethods: tempNotificationMethods,
                    // currentPhoneNumber: tempCurrentPhoneNumber,
                });
            },
        );
    };

    focusReceiverPhoneInput = () => {
        const {receiverTel} = this.props;
        let tempPhoneNumberList = [];

        if (receiverTel) {
            tempPhoneNumberList.push({
                id: 1,
                name: receiverTel,
                receiverTel: receiverTel,
            });

            this.setState({
                phoneNumberList: tempPhoneNumberList,
            });
        }
    };

    focusReceiverEmailInput = () => {
        const {invoiceReceiverEmail} = this.props;
        let tempEmailList = [];

        if (invoiceReceiverEmail) {
            tempEmailList.push({
                id: 1,
                name: invoiceReceiverEmail,
                invoiceReceiverEmail: invoiceReceiverEmail,
            });
            this.setState({
                emailList: tempEmailList,
            });
        }
    };

    handleSelectChange = (name, value) => {
        console.log(name, '999999999999999999999999999999999999999', value);
        const {phoneNumberList, notificationMethods} = this.state;
        let currentNotificationMethods = JSON.parse(
            JSON.stringify(notificationMethods),
        );

        currentNotificationMethods.forEach((notificationItem) => {
            if (notificationItem.method === 'sms') {
                notificationItem.receiver = name.name;
            }
        });
        this.setState({
            phoneNumberId: name.name ? name.id : '',
            notificationMethods: currentNotificationMethods,
            currentPhoneNumber: name.name,
        });
    };

    handleSelectEmailChange = (name, value) => {
        const {emailList, notificationMethods} = this.state;
        let currentNotificationMethods = JSON.parse(
            JSON.stringify(notificationMethods),
        );
        let tempEmailList = JSON.parse(JSON.stringify(emailList));

        this.setState({
            emailId: value.id,
        });
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    closeUploadCredentialDialog = () => {
        this.inputFileRef.current.value = null;
        this.setState({
            uploadCredentialDialogOpened: false,
            chooseImage: null,
        });
    };

    closeOfflineOrderTotalLimitExceedDialog = () => {
        this.setState({
            offlineOrderTotalLimitExceed: false,
        });
    };

    openUploadCredentialDialog = () => {
        let tempFileLimit = '';
        let tempMaxFileSize = 0;
        this.props
            .getUploadFileLimit(UPLOAD_FILE_LIMIT.FILE_LIMIT)
            .then((res) => {
                if (
                    res &&
                    res.payload &&
                    res.payload.status === 'success' &&
                    res.payload.data
                ) {
                    res.payload.data.length > 0 &&
                        res.payload.data.map((fileItem) => {
                            if (fileItem.key === 'allowFileExtensions') {
                                tempFileLimit = fileItem.value
                                    ? fileItem.value.join(',')
                                    : '';
                            }
                            if (fileItem.key === 'maxFileSize') {
                                tempMaxFileSize = fileItem.value;
                            }
                        });
                    this.setState({
                        uploadFileLimit: tempFileLimit,
                        currentMaxFileSize: tempMaxFileSize,
                    });
                }
            });
        this.setState({
            uploadCredentialDialogOpened: true,
        });
    };

    chooseImage = (item) => {
        this.inputFileRef.current.click();
        // this.refs['inputFile'] && this.refs['inputFile'].click();
    };

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;

        // if (!/^image\//.test(ev.target.files[0].type)) {
        //     return this.props.openNotification(
        //         T('notification_please_select_picture'),
        //         'danger',
        //     );
        // }
        const reader = new FileReader();
        const file = ev.target.files[0];

        if (file) {
            reader.onload = (ev) => {
                this.setState({chooseImage: {file, url: ev.target.result}});
            };

            reader.readAsDataURL(file);
        }
    };

    uploadConfirmHandle = () => {
        const {offlineOrderCredential} = this.props;
        let currentImageStreamArr = JSON.parse(
            JSON.stringify(offlineOrderCredential),
        );
        this.setState({
            loading: true,
        });
        if (this.state.chooseImage) {
            this.props
                .uploadOffineFile({
                    type: 'offline_order',
                    file: this.state.chooseImage.file,
                })
                .then((res) => {
                    if (res && res.status === 'success') {
                        let tempFileArr = [];
                        let fileObj = new Object({
                            url: res.url,
                            name: res.name,
                        });
                        tempFileArr.push(fileObj);

                        let offlineOrderFileArr = [
                            ...currentImageStreamArr,
                            ...tempFileArr,
                        ];
                        localStorage.setItem(
                            'offlineOrderCredential',
                            JSON.stringify(offlineOrderFileArr),
                        );
                        this.props.updateOfflineOrderCredential(
                            offlineOrderFileArr,
                        );
                        this.setState({
                            imageStreamArr: [
                                ...currentImageStreamArr,
                                ...tempFileArr,
                            ],
                            loading: false,
                            uploadCredentialDialogOpened: false,
                            chooseImage: null,
                        });
                        this.props.openNotification(
                            T('offline_order_successfully_upload'),
                            'success',
                        );
                    }
                })
                .catch((e) => {
                    this.inputFileRef.current.value = null;
                    this.setState({loading: false, chooseImage: null});
                    // this.props.openNotification(
                    //     T('notification_picture_upload_failed'),
                    //     'danger',
                    // );
                });
        } else {
            this.setState({
                loading: false,
            });
            this.props.openNotification(
                T('host_advent_products_upload_tag_is_not_null'),
                'danger',
            );
        }
    };

    deleteUploadFile = (deleteUrl, deleteIndex) => {
        // const {imageStreamArr} = this.state;
        const {offlineOrderCredential} = this.props;
        let currentImageStreamArr = JSON.parse(
            JSON.stringify(offlineOrderCredential),
        );
        const tempImageArr = currentImageStreamArr.filter(
            (element, index) => index !== deleteIndex,
        );

        localStorage.setItem(
            'offlineOrderCredential',
            JSON.stringify(tempImageArr),
        );
        this.props.updateOfflineOrderCredential(tempImageArr);
        this.setState({
            imageStreamArr: tempImageArr,
            chooseImage: null,
        });
    };

    getCurrentNotificationMethod = (notificationMethods, currentMethod) => {
        let currentReceiver = '';
        if (notificationMethods && notificationMethods.length > 0) {
            notificationMethods.map((notificationItem, notificationIndex) => {
                if (
                    currentMethod === notificationItem.method &&
                    notificationItem.receiver
                ) {
                    currentReceiver = notificationItem.receiver;
                }
            });

            if (currentReceiver) {
                return <span>{currentReceiver}</span>;
            } else {
                return <span>{T('information_na')}</span>;
            }
        }

        return currentReceiver;
    };

    getPurchaseCustomerName = () => {
        let customerName = '';
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerName = routerState.customerName;
        }
        return customerName;
    };

    getPurchaseCustomerEmail = () => {
        let customerEmail = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerEmail = routerState.customerEmail;
        }
        return customerEmail;
    };

    getOffLineOrderIsUploadProofs = () => {
        const {offlineOrderCredential} = this.props;
        let isUploadProofs = false;
        if (util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE) {
            if (offlineOrderCredential && offlineOrderCredential.length > 0) {
                isUploadProofs = true;
            } else {
                isUploadProofs = false;
            }
        } else {
            isUploadProofs = false;
        }
        return isUploadProofs;
    };

    setCurrentOrderLines = (orderLines) => {
        this.setState({
            orderLines: orderLines,
        });
    };
    setCurrentTfsOrderLines = (orderLines) => {
        this.setState({
            tfsOrderLines: orderLines,
        });
    };

    isOfflineOrderVisibleUnderLimit = () => {
        const {localData} = this.props;

        return Number(localData.totalPrice || 0) <= 60000;
    };

    render() {
        const {
            shippmentType,
            confirmDialogOpened,
            billToConsignee,
            billToPhone,
            tabActive,
            note,
            noteTF,
            poNumber,
            poNumberTF,
            expectShipDate,
            selectedValue,
            checked,
            billToEmail,
            email,
            billToConsigneeSearch,
            isMobilityNotification,
            isSMS,
            isEmail,
            phoneNumberList,
            phoneNumber,
            phoneNumberId,
            emailList,
            emailId,
            defaultEmail,
            retentionTime,
            offlineOrderSelectValue,
            uploadCredentialDialogOpened,
            chooseImage,
            loading,
            imageStreamArr,
            notificationMethods,
            uploadFileLimit,
            offlineOrderTotalLimitExceed,
        } = this.state;
        const {
            CRD_RangeList,
            tfsProducts,
            scmProducts,
            hostInfo,
            orderShipTo,
            receiver,
            receiverTel,
            stContactQuery,
            localData,
            invoiceReceiver,
            invoiceReceiverTel,
            invoiceReceiverEmail,
            offlineOrderCredential,
        } = this.props;
        const tabs = this.tabFilter();
        // console.log("billToConsignee", billToConsignee);

        console.log(
            'stContactQuery===================================',
            stContactQuery,
        );
        let lang = loadLanguage();
        let isTF = false;
        let products = scmProducts;
        if (CRD_RangeList && products) {
            products
                .filter((x) => !x.freeGoodItem)
                .forEach((product) => {
                    product.deliveryChannel = 'SC';
                    const crdRangeItem = CRD_RangeList.crdRanges.find(
                        (crdRange) => {
                            return (
                                crdRange.catalogNumber === product.sku &&
                                crdRange.lineNumber === product.lineNumber &&
                                crdRange.deliveryChannel ===
                                    product.deliveryChannel
                            );
                        },
                    );
                    if (crdRangeItem) {
                        product.CRD_Range = crdRangeItem;
                        product.crd = crdRangeItem.defaultDate;
                    }
                });
        }
        let officialWebProducts = tfsProducts;
        if (CRD_RangeList && officialWebProducts) {
            officialWebProducts
                .filter((x) => !x.freeGoodItem)
                .forEach((product) => {
                    product.deliveryChannel = 'TFS';
                    const crdRangeItem = CRD_RangeList.crdRanges.find(
                        (crdRange) => {
                            return (
                                crdRange.catalogNumber === product.sku &&
                                crdRange.lineNumber === product.lineNumber &&
                                crdRange.deliveryChannel ===
                                    product.deliveryChannel
                            );
                        },
                    );
                    if (crdRangeItem) {
                        product.CRD_Range = crdRangeItem;
                        product.crd = crdRangeItem.defaultDate;
                    }
                });
        }

        return (
            <div className="order-confirmation lto-order-confirmation">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    increment={0}
                    hasUserCenter={true}
                    isOrderConfiramation={true}
                    hasArrowBackIos={true}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>{T('orderConfirmation')}</span>
                        </Grid>
                    </Grid>
                </Header>

                <Grid
                    id="ST_information"
                    className="ship-to-box-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="ship-to-box" item xs={11}>
                        <ShipToConfirm
                            shipToInfo={orderShipTo}
                            hostInfo={hostInfo}
                            receiver={receiver}
                            receiverTel={receiverTel}
                            handleChange={this.handleChange}
                            handleChangeRadio={this.handleChangeRadio}
                            selectedValue={shippmentType}
                            isProxyProcess={
                                this.getBatchAddSkuShipTo()
                                    ? true
                                    : localData.isProxyProcess
                            }></ShipToConfirm>
                    </Grid>
                </Grid>

                <Grid
                    id="BT_information"
                    className="bill-to-box-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="bill-to-box" item xs={11}>
                        <BillToConfirm
                            shipToInfo={orderShipTo}
                            receiver={invoiceReceiver}
                            receiverTel={invoiceReceiverTel}
                            handleChange={this.handleChange}
                            billToConsignee={billToConsignee}
                            billToPhone={billToPhone}
                            invoiceReceiverEmail={invoiceReceiverEmail}
                            billToEmail={billToEmail}
                            stContactList={stContactQuery}
                            handleSearch={this.handleSearch}
                            billToConsigneeSearch={billToConsigneeSearch}
                            isProxyProcess={
                                this.getBatchAddSkuShipTo()
                                    ? true
                                    : localData.isProxyProcess
                            }></BillToConfirm>
                    </Grid>
                </Grid>

                {(products && products.length > 0) ||
                (officialWebProducts && officialWebProducts.length > 0) ? (
                    <div>
                        {/* <div
                            id="order-confirma-tab-header"
                            className="tab-header">
                            {tabs.map((item, index) => {
                                return (
                                    <Anchor
                                        key={item.index}
                                        className={util.getClassName({
                                            'tab-item': true,
                                            active:
                                                item.index === tabActive ||
                                                tabs[0].index === 1,
                                        })}
                                        onClickOfSingleTap={() => {
                                            this.handleChangeTab(item);
                                        }}>
                                        {' '}
                                        {item.text}{' '}
                                    </Anchor>
                                );
                            })}
                        </div> */}

                        {products && products.length > 0 && (
                            <Grid
                                className="product-details-list-container no-margin"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <ProductDetails
                                        productList={products}
                                        holidays={
                                            CRD_RangeList
                                                ? CRD_RangeList.holidays
                                                : []
                                        }
                                        skuDetailsList={localData.skuPrices}
                                        isTF={false}
                                        setCurrentOrderLines={
                                            this.setCurrentOrderLines
                                        }
                                    />
                                </Grid>
                            </Grid>
                        )}

                        {officialWebProducts &&
                            officialWebProducts.length > 0 && (
                                <Grid
                                    className="product-details-list-container no-margin tfs-product-container"
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    <Grid item xs={11}>
                                        <ProductDetails
                                            productList={officialWebProducts}
                                            holidays={
                                                CRD_RangeList
                                                    ? CRD_RangeList.holidays
                                                    : []
                                            }
                                            skuDetailsList={localData.skuPrices}
                                            isTF={true}
                                            setCurrentOrderLines={
                                                this.setCurrentTfsOrderLines
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="customer-confirmation-channel-container no-margin"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <Card className="order-card">
                                        <h3>
                                            {T(
                                                'lto_purchase_order_customer_confirmation_channel',
                                            )}
                                        </h3>
                                        <div className="confirmation-channel-label">
                                            {T(
                                                'lto_purchase_order_please_select_customer_confirmation_channel',
                                            )}
                                        </div>
                                        <div className="confirmation-channel-option">
                                            <Checkbox
                                                checked={isMobilityNotification}
                                                onChange={this.handleCustomerConfirmationChannel.bind(
                                                    this,
                                                    'isMobilityNotification',
                                                    isMobilityNotification,
                                                )}
                                                disabled={true}
                                                className="checkbox-button"
                                            />
                                            <span className="all-selected-title">
                                                {T(
                                                    'lto_purchase_order_mobility',
                                                )}
                                            </span>
                                        </div>
                                        <div className="confirmation-channel-option">
                                            <Checkbox
                                                checked={isSMS}
                                                onChange={this.handleCustomerConfirmationChannel.bind(
                                                    this,
                                                    'isSMS',
                                                    isSMS,
                                                )}
                                                className="checkbox-button"
                                            />
                                            <span className="all-selected-title">
                                                <label>
                                                    {T('phoneNumber')}
                                                </label>
                                                <Select
                                                    className="select"
                                                    value={phoneNumberId}
                                                    placeholder={T(
                                                        'select_customer_confirmation_channel_phone_number',
                                                    )}
                                                    data={phoneNumberList}
                                                    displayKey="name"
                                                    valueKey="id"
                                                    onChange={
                                                        this.handleSelectChange
                                                    }
                                                    options={{
                                                        icon: {
                                                            show: true,
                                                            color: '#E82D38',
                                                        },
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="confirmation-channel-option">
                                            <Checkbox
                                                checked={isEmail}
                                                onChange={this.handleCustomerConfirmationChannel.bind(
                                                    this,
                                                    'isEmail',
                                                    isEmail,
                                                )}
                                                className="checkbox-button"
                                            />
                                            <div className="all-selected-title">
                                                <label className="default-email-label">
                                                    {T('defaultEmail')}
                                                </label>
                                                <div className="default-email">
                                                    {defaultEmail}
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="keep-time-until-container no-margin"
                                id="keepTimeInput"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <Card className="order-card">
                                        <Grid
                                            className="retention-time-info"
                                            item
                                            xs={12}>
                                            <label>
                                                {T(
                                                    'retentionTimeNotMoreThan14Days',
                                                )}
                                            </label>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={11}
                                            className="retention-time-grid-container">
                                            <Grid
                                                item
                                                xs={9}
                                                className="retention-time-container">
                                                <BasicInput
                                                    type={'date'}
                                                    inputValid={
                                                        this.handleChange
                                                    }
                                                    defaultValue={retentionTime}
                                                    title="retentionTime"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={2}
                                                className="retention-time-tip">
                                                <label>
                                                    {T('retentionTime_tip')}
                                                </label>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                        )}

                        <Grid
                            className="po-container no-margin lto-po-container"
                            id={
                                util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.OFFLINE
                                    ? 'offlinPoinput'
                                    : 'po_input'
                            }
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid item xs={11}>
                                <Card className="order-card">
                                    {tabActive === 0 ? (
                                        <LabelInput
                                            title={
                                                isTF ? 'poNumberTF' : 'poNumber'
                                            }
                                            defaultValue={
                                                isTF ? poNumberTF : poNumber
                                            }
                                            placeholder={T(
                                                'enter_purchase_number',
                                            )}
                                            inputValid={this.handleChange}
                                            testid="po-input"
                                            type="text"
                                        />
                                    ) : (
                                        <div>
                                            <Grid
                                                className="purchase-number-label"
                                                item
                                                xs={6}>
                                                <span>{T('poNumberTF')}</span>
                                            </Grid>
                                            <div className="po-radio-label">
                                                <RadioGroup
                                                    onChange={this.handleRadio.bind(
                                                        this,
                                                        'poNumber',
                                                    )}>
                                                    <FormControlLabel
                                                        className="po-radio"
                                                        value="1"
                                                        control={<Radio />}
                                                        label={T(
                                                            'order_same_supply_center',
                                                        )}
                                                    />
                                                </RadioGroup>
                                            </div>
                                            <Grid
                                                className="purchase-number-content"
                                                item
                                                xs={12}>
                                                <Input
                                                    type="text"
                                                    title={'poNumberTF'}
                                                    onChange={this.handleChange}
                                                    value={poNumberTF}
                                                    placeholder={T(
                                                        'enter_purchase_number',
                                                    )}
                                                />
                                            </Grid>
                                        </div>
                                    )}
                                </Card>
                            </Grid>
                        </Grid>

                        {/* {!isTF && localData.isProxyProcess ? (
                            <Grid
                                className="date-container no-margin"
                                id="date_input"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <Card className="order-card">
                                        <LabelInput
                                            title={'expectShipDate'}
                                            type={'date'}
                                            inputValid={this.handleChange}
                                            defaultValue={expectShipDate}
                                        />
                                    </Card>
                                </Grid>
                            </Grid>
                        ) : null} */}

                        <Grid
                            className={
                                !isTF
                                    ? 'note-container no-margin is-not-tfs'
                                    : 'note-container no-margin tfs-order'
                            }
                            id="remark_input"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid item xs={11}>
                                <Card className="order-card">
                                    {tabActive === 0 ? (
                                        <>
                                            {this.isOemOnlyOrder() && !isTF && (
                                                <div className="oem-order-remark-tip">
                                                    {T(
                                                        'oem_order_remark_placeholder',
                                                    )}
                                                </div>
                                            )}
                                            <LabelInput
                                                title={isTF ? 'noteTF' : 'note'}
                                                testid={
                                                    isTF
                                                        ? 'note-tf-input'
                                                        : 'note-input'
                                                }
                                                defaultValue={
                                                    isTF ? noteTF : note
                                                }
                                                placeholder={T('enter_note')}
                                                showRequiredMark={
                                                    this.isOemOnlyOrder() &&
                                                    !isTF
                                                }
                                                inputValid={this.handleChange}
                                                type="text"
                                            />
                                        </>
                                    ) : (
                                        <div>
                                            <Grid
                                                className="purchase-number-label"
                                                item
                                                xs={6}>
                                                <span>{T('noteTF')}</span>
                                            </Grid>
                                            <div className="note-radio-label">
                                                <RadioGroup
                                                    onChange={this.handleRadio.bind(
                                                        this,
                                                        'note',
                                                    )}>
                                                    <FormControlLabel
                                                        className="note-radio"
                                                        value="1"
                                                        control={<Radio />}
                                                        label={T(
                                                            'order_same_supply_center',
                                                        )}
                                                    />
                                                </RadioGroup>
                                            </div>
                                            <Grid
                                                className="purchase-number-content"
                                                item
                                                xs={12}>
                                                <Input
                                                    type="text"
                                                    title={'noteTF'}
                                                    onChange={this.handleChange}
                                                    value={noteTF}
                                                    placeholder={T(
                                                        'enter_note',
                                                    )}
                                                />
                                            </Grid>
                                        </div>
                                    )}
                                </Card>
                            </Grid>
                        </Grid>

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.OFFLINE &&
                            !this.isOfflineOrderVisibleUnderLimit() && (
                                <Grid
                                    className="offline-customer-purchase-order-container no-margin"
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    <Grid item xs={11}>
                                        <Card className="order-card">
                                            <Grid
                                                className="purchase-order-radio"
                                                item
                                                xs={12}>
                                                <Grid
                                                    className="purchase-order-radio-item"
                                                    testid={
                                                        this.isAnnualAgreementCustomer()
                                                            ? 'annual-customer-title'
                                                            : 'non-annual-customer-title'
                                                    }>
                                                    {this.getOfflineUploadTitle()}
                                                </Grid>
                                                <Grid className="upload-order-message">
                                                    <div>
                                                        {T(
                                                            'offline_platform_customer_information',
                                                        )}
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    className="upload-attachment-container"
                                                    testid={
                                                        this.isAnnualAgreementCustomer()
                                                            ? 'annual-customer-upload-attachment'
                                                            : 'non-annual-customer-upload-attachment'
                                                    }
                                                    onClick={() =>
                                                        this.openUploadCredentialDialog()
                                                    }>
                                                    <Attachment />
                                                    {T(
                                                        'offline_platform_customer_add_attachment',
                                                    )}
                                                </Grid>
                                                <Grid
                                                    className="upload-attachment-files"
                                                    item
                                                    xs={12}>
                                                    {offlineOrderCredential &&
                                                    offlineOrderCredential.length >
                                                        0
                                                        ? offlineOrderCredential.map(
                                                              (
                                                                  imageItem,
                                                                  imageIndex,
                                                              ) => {
                                                                  return (
                                                                      imageItem && (
                                                                          <div
                                                                              className="upload-file"
                                                                              key={
                                                                                  imageIndex
                                                                              }>
                                                                              <Attachment />
                                                                              <div className="text-ellipsis">
                                                                                  {
                                                                                      imageItem.name
                                                                                  }
                                                                              </div>
                                                                              {/* {T(
                                                                              'lto_purchase_upload_file',
                                                                              [
                                                                                  ++imageIndex,
                                                                              ],
                                                                          )}
                                                                          {' '} */}
                                                                              <span
                                                                                  class="delete-btn"
                                                                                  onClick={() =>
                                                                                      this.deleteUploadFile(
                                                                                          imageItem,
                                                                                          imageIndex,
                                                                                      )
                                                                                  }>
                                                                                  {T(
                                                                                      'lto_purchase_upload_file_delete',
                                                                                  )}
                                                                              </span>
                                                                          </div>
                                                                      )
                                                                  );
                                                              },
                                                          )
                                                        : null}
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                </Grid>
                            )}

                        {!isTF ? (
                            <Grid
                                className="eone-display-price-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="display-price-label"
                                    item
                                    xs={6}>
                                    <span>{T('show_eone_set_price')}</span>
                                </Grid>
                                <Grid
                                    className="display-price-value"
                                    item
                                    xs={5}>
                                    {orderShipTo.priceDisplayFlag === 'Y'
                                        ? T('eone_set_show_price')
                                        : T('eone_set_not_show_price')}
                                </Grid>
                            </Grid>
                        ) : null}
                        {/*										                { isTF ? <Grid className='tf-notification no-margin' container spacing={0} justify={'space-evenly'}>
														      		<Grid item xs={12}>
																		<span>别忘了确认官网商品订单内容哦！</span>
													                </Grid>
												                 </Grid> : null }*/}
                    </div>
                ) : null}

                <Grid className="check-content" container spacing={0}>
                    <Checkbox
                        checked={checked}
                        onChange={this.handleChangeCheckbox('checked')}
                        className="checkbox-button"
                        testid="sales-terms-checkbox"
                        inputProps={{testid: 'order-agreement-checkbox'}}
                    />
                    <Grid item xs={10}>
                        <span className="clause">
                            {T('clause_content_one')}
                            <a href="https://www.thermofisher.com/cn/zh/home/global/terms-and-conditions.html">
                                {T('clause_content_two')}
                            </a>
                        </span>
                        <br />
                        <span className="clause">
                            {T('clause_content_three')}
                        </span>
                    </Grid>
                </Grid>

                <Grid className="bottom-content" container spacing={0}>
                    {/*<Grid item xs={3}/>*/}
                    <Grid className="final-price" item xs={8}>
                        {T('order_total_colon')}{' '}
                        <span className="price-font">
                            <i className="rmb"></i>{' '}
                            <span className="price" testid="order-total-price">
                                {util.toMoney(localData.totalPrice || 0)}
                            </span>
                        </span>
                    </Grid>
                    <Grid item xs={4}>
                        <BasicButton
                            type="primary"
                            testid="submit-order-btn"
                            onClickOfSingleTap={this.submitOrder}>
                            {/* <span>
                                {tabActive === 0 &&
                                tfsProducts &&
                                tfsProducts.length > 0 &&
                                scmProducts &&
                                scmProducts.length > 0
                                    ? T('order_next_step')
                                    : T('order_submit_order')}
                            </span> */}
                            <span>{T('order_submit_order')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>

                <Dialog
                    options={{bgClickClose: true}}
                    notSetDialogTop={true}
                    dialogId="submitOrderConfiration"
                    opened={confirmDialogOpened}
                    dialogDidClose={this.closeDialog}>
                    <div
                        testid="submit-order-confirmation-popup"
                        className={
                            util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE
                                ? 'confirm-popup online-confirm-popup'
                                : 'confirm-popup'
                        }>
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                <span>
                                    {util.getPurchaseOrderMode() ===
                                    PURCHASE_ORDER_MODE.ONLINE
                                        ? T('information_confirm')
                                        : T('order_confirm_information_again')}
                                </span>
                            </Grid>
                        </Grid>

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container online-order-confirm-message"
                                container
                                spacing={0}>
                                <Grid className="online-confirm-content-grid">
                                    <span>
                                        {T('please_confirm_info_is_correct')}
                                    </span>
                                </Grid>
                            </Grid>
                        )}

                        <Grid
                            className="comfirm-content-container"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid className="confirm-label-grid">
                                <span>{T('order_invoice_title')}</span>
                            </Grid>
                            <Grid className="confirm-content-grid">
                                <span>
                                    {orderShipTo
                                        ? orderShipTo.btInstitution
                                        : ''}
                                </span>
                            </Grid>
                        </Grid>

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-label-grid">
                                    <span>{T('retentionTime')}</span>
                                </Grid>
                                <Grid className="confirm-content-grid">
                                    <span>{retentionTime}</span>
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-label-grid">
                                    <span>{T('confirm_phoneNumber')}</span>
                                </Grid>
                                <Grid className="confirm-content-grid">
                                    {notificationMethods &&
                                    notificationMethods.length > 0 ? (
                                        this.getCurrentNotificationMethod(
                                            notificationMethods,
                                            'sms',
                                        )
                                    ) : (
                                        <span>{T('information_na')}</span>
                                    )}
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-label-grid">
                                    <span>{T('confirm_email')}</span>
                                </Grid>
                                <Grid className="confirm-content-grid">
                                    {notificationMethods &&
                                    notificationMethods.length > 0 ? (
                                        this.getCurrentNotificationMethod(
                                            notificationMethods,
                                            'mail',
                                        )
                                    ) : (
                                        <span>{T('information_na')}</span>
                                    )}
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.OFFLINE && (
                            <Grid>
                                <Grid className="important-reminder-area">
                                    <Grid className="important-reminder">
                                        {T('order_invoice_important_reminder')}
                                    </Grid>
                                    <Grid
                                        className={util.getClassName({
                                            'important-reminder-text': true,
                                            'offline-order-important-reminder-text':
                                                util.getPurchaseOrderMode() ===
                                                PURCHASE_ORDER_MODE.OFFLINE,
                                        })}>
                                        {T(
                                            'offline_order_invoice_important_reminder_rule_title_new',
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid className="important-teminder-item">
                                    <ol>
                                        <li>
                                            {T(
                                                'order_invoice_important_reminder_rule_1_1_new',
                                            )}
                                            <label>
                                                <a
                                                    href={openTfsRuleUrl}
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    {T(
                                                        'order_invoice_important_reminder_rule_1_2_new',
                                                    )}
                                                </a>
                                            </label>
                                            {T(
                                                'order_invoice_important_reminder_rule_1_6_new',
                                            )}
                                            <label className="rule_1_3">
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_3_new',
                                                )}
                                            </label>
                                            {T(
                                                'order_invoice_important_reminder_rule_1_4_new',
                                            )}
                                            <label className="rule_1_5">
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_5_new',
                                                )}
                                            </label>
                                            {T(
                                                'order_invoice_important_reminder_rule_1_7_new',
                                            )}
                                        </li>
                                        <li>
                                            {T(
                                                'order_invoice_important_reminder_rule_2_1_new',
                                            )}
                                            <label>
                                                <a
                                                    href={openTfsChangeRuleUrl}
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    {T(
                                                        'order_invoice_important_reminder_rule_2_2_new',
                                                    )}
                                                </a>
                                            </label>
                                            {T(
                                                'order_invoice_important_reminder_rule_2_3_new',
                                            )}
                                            <label className="rule_2_4">
                                                {T(
                                                    'order_invoice_important_reminder_rule_2_4_new',
                                                )}
                                            </label>
                                            {T(
                                                'order_invoice_important_reminder_rule_2_5_new',
                                            )}
                                        </li>
                                        <li>
                                            {T(
                                                'order_invoice_important_reminder_rule_3_1_new',
                                            )}
                                        </li>
                                    </ol>
                                </Grid>
                            </Grid>
                        )}

                        <Grid
                            className="default-button-container"
                            container
                            spacing={0}>
                            <Grid className="default-button-grid" item xs={12}>
                                {util.getPurchaseOrderMode() ===
                                    PURCHASE_ORDER_MODE.ONLINE && (
                                    <BasicButton
                                        testid="submit-order-cancel-btn"
                                        type="primary"
                                        disabled={false}
                                        onClickOfSingleTap={this.closeDialog}>
                                        <span>{T('cancel')}</span>
                                    </BasicButton>
                                )}
                                <BasicButton
                                    testid="submit-order-confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.confirmDialog}>
                                    <span>
                                        {util.getPurchaseOrderMode() ===
                                        PURCHASE_ORDER_MODE.ONLINE
                                            ? T('online_confirm')
                                            : T('order_complete_confirm_new')}
                                    </span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    opened={uploadCredentialDialogOpened}
                    notSetDialogTop={true}
                    dialogId="offlineUploadCredential"
                    dialogDidClose={() => this.closeUploadCredentialDialog()}
                    options={{bgClickClose: true}}>
                    <div className="upload-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {T('lto_purchase_upload_file_confirm_upload_tag')}
                        </h5>
                        <div className="upload-file-format">
                            {T('upload_file_format', [uploadFileLimit])}
                        </div>
                        <div className="credential-tag-upload-dialog-desc text-center">
                            <BaseImageUploader
                                className={util.getClassName({
                                    'upload-method-upload text-center text-ellipsis':
                                        true && lang !== 'EN',
                                    'en-upload-method-upload text-center text-ellipsis':
                                        true && lang === 'EN',
                                })}
                                id={
                                    chooseImage &&
                                    chooseImage.url &&
                                    chooseImage.file &&
                                    chooseImage.file.type.indexOf('image/') ===
                                        -1
                                        ? 'notImageType'
                                        : ''
                                }
                                onClickOfSingleTap={this.chooseImage}>
                                {chooseImage && chooseImage.url ? (
                                    chooseImage.file &&
                                    chooseImage.file.type.indexOf('image/') ===
                                        -1 ? (
                                        <div className="credential-file-name">
                                            {chooseImage.file.name &&
                                            chooseImage.file.name.length > 22
                                                ? chooseImage.file.name.substring(
                                                      0,
                                                      22,
                                                  ) + '...'
                                                : chooseImage.file.name}
                                        </div>
                                    ) : (
                                        <img src={chooseImage.url} alt="" />
                                    )
                                ) : (
                                    <>
                                        <span className="upload-method-upload-icon" />
                                        <span className="upload-method-upload-text">
                                            {T('purchase_order_upload_here')}
                                        </span>
                                    </>
                                )}
                                <input
                                    // ref="inputFile"
                                    ref={this.inputFileRef}
                                    type="file"
                                    onChange={this.selectedImage}
                                />
                            </BaseImageUploader>
                        </div>
                        <div className="upload-method-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                loading={loading}
                                onClickOfSingleTap={this.uploadConfirmHandle}>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                className="upload-method-cancel"
                                onClickOfSingleTap={() =>
                                    this.closeUploadCredentialDialog()
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={offlineOrderTotalLimitExceed}
                    testid="important-reminder-dialog"
                    notSetDialogTop={true}
                    dialogId="offlineOrderTotalLimitExceed"
                    dialogDidClose={() =>
                        this.closeOfflineOrderTotalLimitExceedDialog()
                    }
                    options={{bgClickClose: true}}>
                    {/* <div className="offline-order-limit-exceed-dialog">
                        <h5 className="offline-order-limit-exceed-dialog-title text-center">
                            {T('lto_purchase_order_is_not_submit')}
                        </h5>
                        <div className="offline-order-limit-exceed-message1 offline-order-limit-exceed-content">
                            {T('offline_ordertotal_limit_exceed_message1')}
                        </div>
                        <div className="offline-order-limit-exceed-message2 offline-order-limit-exceed-content">
                            {T('offline_ordertotal_limit_exceed_message2')}
                        </div>
                        <div className="offline-order-limit-exceed-message3 offline-order-limit-exceed-content">
                            {T('offline_ordertotal_limit_exceed_message3')}
                        </div>
                        <div className="tag-upload-btn-container">
                            <BasicButton
                                className="primary cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.closeOfflineOrderTotalLimitExceedDialog()
                                }>
                                {T(
                                    'lto_purchase_order_is_not_submit_btn_label',
                                )}
                            </BasicButton>
                        </div>
                    </div> */}

                    <div
                        className={
                            util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE
                                ? 'confirm-popup online-confirm-popup'
                                : 'confirm-popup'
                        }>
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid
                                className={
                                    util.getPurchaseOrderMode() ===
                                    PURCHASE_ORDER_MODE.OFFLINE
                                        ? 'confirm-title-grid offline-order-title-text'
                                        : 'confirm-title-grid'
                                }
                                item
                                xs={12}>
                                <span
                                    className={
                                        !this.getOffLineOrderIsUploadProofs()
                                            ? 'important-title'
                                            : ''
                                    }>
                                    {this.getOffLineOrderIsUploadProofs()
                                        ? T('order_confirm_information_again')
                                        : T('order_invoice_offline_reminder')}
                                </span>
                            </Grid>
                        </Grid>

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container online-order-confirm-message"
                                container
                                spacing={0}>
                                <Grid className="online-confirm-content-grid">
                                    <span>
                                        {T('please_confirm_info_is_correct')}
                                    </span>
                                </Grid>
                            </Grid>
                        )}

                        <Grid
                            className={
                                util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.OFFLINE
                                    ? 'comfirm-content-container offline-confirm-title-container'
                                    : 'comfirm-content-container'
                            }
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid className="confirm-label-grid">
                                <span>{T('order_invoice_title')}</span>
                            </Grid>
                            <Grid className="confirm-content-grid">
                                <span>
                                    {orderShipTo
                                        ? orderShipTo.btInstitution
                                        : ''}
                                </span>
                            </Grid>
                        </Grid>

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-label-grid">
                                    <span>{T('retentionTime')}</span>
                                </Grid>
                                <Grid className="confirm-content-grid">
                                    <span>{retentionTime}</span>
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-label-grid">
                                    <span>{T('confirm_phoneNumber')}</span>
                                </Grid>
                                <Grid className="confirm-content-grid">
                                    {notificationMethods &&
                                    notificationMethods.length > 0 ? (
                                        this.getCurrentNotificationMethod(
                                            notificationMethods,
                                            'sms',
                                        )
                                    ) : (
                                        <span>{T('information_na')}</span>
                                    )}
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-label-grid">
                                    <span>{T('confirm_email')}</span>
                                </Grid>
                                <Grid className="confirm-content-grid">
                                    {notificationMethods &&
                                    notificationMethods.length > 0 ? (
                                        this.getCurrentNotificationMethod(
                                            notificationMethods,
                                            'mail',
                                        )
                                    ) : (
                                        <span>{T('information_na')}</span>
                                    )}
                                </Grid>
                            </Grid>
                        )}

                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.OFFLINE && (
                            <Grid>
                                <Grid className="important-reminder-area">
                                    {this.getOffLineOrderIsUploadProofs() && (
                                        <Grid className="important-reminder">
                                            {T(
                                                'order_invoice_important_reminder',
                                            )}
                                        </Grid>
                                    )}
                                    <Grid
                                        className={util.getClassName({
                                            'important-reminder-text': true,
                                            'offline-order-first-reminder-text':
                                                !this.getOffLineOrderIsUploadProofs(),
                                        })}>
                                        {offlineOrderCredential &&
                                        offlineOrderCredential.length > 0 ? (
                                            <>
                                                {T(
                                                    'offline_order_invoice_important_reminder_rule_title_new_part1',
                                                )}
                                                <span className="important-reminder-highlight">
                                                    {T(
                                                        'offline_order_invoice_important_reminder_rule_title_new_part2',
                                                    )}
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                {T(
                                                    'offline_order_invoice_important_reminder_total_limit_exceed_part1',
                                                )}
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                                {(() => {
                                    const isNoCredential =
                                        offlineOrderCredential &&
                                        offlineOrderCredential.length === 0;
                                    const ListTag = isNoCredential
                                        ? 'ul'
                                        : 'ol';

                                    const reminderItems = (
                                        <>
                                            <li>
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_1_new',
                                                )}
                                                <label>
                                                    <a
                                                        href={openTfsRuleUrl}
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        {T(
                                                            'order_invoice_important_reminder_rule_1_2_new',
                                                        )}
                                                    </a>
                                                </label>
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_6_new',
                                                )}
                                                <label
                                                    className={
                                                        this.getOffLineOrderIsUploadProofs()
                                                            ? 'rule_1_3'
                                                            : ''
                                                    }>
                                                    {T(
                                                        'order_invoice_important_reminder_rule_1_3_new',
                                                    )}
                                                </label>
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_4_new',
                                                )}
                                                <label
                                                    className={
                                                        this.getOffLineOrderIsUploadProofs()
                                                            ? 'rule_1_5'
                                                            : ''
                                                    }>
                                                    {T(
                                                        'order_invoice_important_reminder_rule_1_5_new',
                                                    )}
                                                </label>
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_7_new',
                                                )}
                                            </li>
                                            <li>
                                                {T(
                                                    'order_invoice_important_reminder_rule_2_1_new',
                                                )}
                                                <label>
                                                    <a
                                                        href={
                                                            openTfsChangeRuleUrl
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        {T(
                                                            'order_invoice_important_reminder_rule_2_2_new',
                                                        )}
                                                    </a>
                                                </label>
                                                {T(
                                                    'order_invoice_important_reminder_rule_2_3_new',
                                                )}
                                                <label
                                                    className={
                                                        this.getOffLineOrderIsUploadProofs()
                                                            ? 'rule_2_4'
                                                            : ''
                                                    }>
                                                    {T(
                                                        'order_invoice_important_reminder_rule_2_4_new',
                                                    )}
                                                </label>
                                                {T(
                                                    'order_invoice_important_reminder_rule_2_5_new',
                                                )}
                                            </li>
                                            <li>
                                                {T(
                                                    'order_invoice_important_reminder_rule_3_1_new',
                                                )}
                                            </li>
                                        </>
                                    );

                                    return (
                                        <Grid className="important-teminder-item total_limit_exceed_reminder">
                                            {isNoCredential && (
                                                <ol className="no-credential-order">
                                                    <li>
                                                        {T(
                                                            'offline_order_invoice_important_reminder_total_limit_exceed_part2',
                                                        )}
                                                    </li>
                                                    <li>
                                                        {T(
                                                            'offline_order_invoice_important_reminder_total_limit_exceed_part3',
                                                        )}
                                                    </li>
                                                </ol>
                                            )}

                                            <ListTag>{reminderItems}</ListTag>
                                        </Grid>
                                    );
                                })()}
                            </Grid>
                        )}

                        <Grid
                            className="default-button-container"
                            container
                            spacing={0}>
                            <Grid
                                className="default-button-grid more-than-total"
                                item
                                xs={12}>
                                {offlineOrderCredential &&
                                    offlineOrderCredential.length === 0 && (
                                        <BasicButton
                                            type="primary"
                                            testid="important-reminder-back-btn"
                                            disabled={false}
                                            onClickOfSingleTap={
                                                this
                                                    .closeOfflineOrderTotalLimitExceedDialog
                                            }>
                                            <span>
                                                {T(
                                                    'lto_purchase_order_is_not_submit_btn_label',
                                                )}
                                            </span>
                                        </BasicButton>
                                    )}
                                <BasicButton
                                    type="primary"
                                    testid="important-reminder-confirm-btn"
                                    disabled={false}
                                    onClickOfSingleTap={this.confirmDialog}>
                                    <span>
                                        {offlineOrderCredential &&
                                        offlineOrderCredential.length === 0
                                            ? T('order_confirm_submit')
                                            : T('order_complete_confirm_new')}
                                    </span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {order, localData, ltoPurchaseOrder} = state;
    return {
        localData: localData,
        hostInfo: order.previewOrder.host,
        scmProducts: order.previewOrder.scmProducts,
        tfsProducts: order.previewOrder.tfsProducts,
        CRD_RangeList: order.CRD_RangeList,
        orderShipTo: order.previewOrder.shipTo,
        annualAgreementCustomerFlag:
            order.previewOrder.annualAgreementCustomerFlag,
        receiver: order.previewOrder.receiver,
        receiverTel: order.previewOrder.receiverTel,
        invoiceReceiver: order.previewOrder.invoiceReceiver,
        invoiceReceiverTel: order.previewOrder.invoiceReceiverTel,
        stContactQuery: order.stContactQuery,
        customerRowId: order.previewOrder.rowId,
        orderNumbers: order.previewOrder.orderNumbers,
        invoiceReceiverEmail: order.previewOrder.invoiceReceiverEmail,
        addProxyOrder: ltoPurchaseOrder.addProxyOrder,
        offlineOrderCredential: order.offlineOrderCredential,
        fileLimits: order.fileLimits,
    };
};

const mapDispatchToProps = {
    previewOrder,
    updatePreviewOrder,
    getShipToInfo,
    queryStContact,
    openNotification,
    addProxyOrder,
    uploadOffineFile,
    updateOfflineOrderCredential,
    getUploadFileLimit,
    get_CRD_Range,
    queryEoneInventory,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation);
